import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  DataGridView,
  usePub,
  useSub,
} from "@neumetric/blueprint-lib/components";
import { mitigatorActions, getVulnerabilitiesByStatus } from "../../../store";

const PER_PAGE = process.env.REACT_APP_INC_PER_PAGE || 9;

const vulnerabilityColumns = [
  {
    dataIndex: "vulnerability_id",
    typeRepresentation: "LINK",
    title: "Vulnerability ID",
    width: "18%",
  },
  {
    dataIndex: "category",
    typeRepresentation: "TEXT",
    title: "Category",
    width: "15%",
    showTooltip: true,
  },
  {
    dataIndex: "vulnerability",
    typeRepresentation: "TEXT",
    title: "Vulnerability",
    width: "17%",
    showTooltip: true,
  },
  {
    dataIndex: "threat",
    typeRepresentation: "TEXT",
    title: "Threat",
    width: "50%",
    searchableFlag: true,
    sortableFlag: true,
    searchMode: "SERVER",
    showTooltip: true,
  },
];

const getTab = () => {
  let currentUrlParams = new URLSearchParams(window.location.search);
  return currentUrlParams.get("tab") || "active";
};
const getPage = () => {
  let currentUrlParams = new URLSearchParams(window.location.search);
  return currentUrlParams.get("page") || 1;
};

export const MitigatorVulnerabilityTrackerScreen = () => {
  const [state, setState] = React.useState({
    activeSubmenu: getTab(),
  });
  const [vulTableSelectedKeys, setVulTableSelectedKeys] = React.useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const publish = usePub();
  const _ref = React.useRef(null);
  const _filter = React.useRef({
    defaultPage: getPage(),
    pageNo: getPage(),
    search: "",
    pageSize: PER_PAGE,
  });
  const vulnerabilitiesList =
    useSelector(
      getVulnerabilitiesByStatus.bind(null, state.activeSubmenu.toLowerCase())
    ) || [];
  useEffect(() => {
    fetchVulneraiblities();
  }, []);
  useSub("MITIGATOR_SUBMENU_TAB", (data) => {
    setState({
      activeSubmenu: data.tab,
    });
  });
  useSub("MITIGATOR_CLEAR_TABLE_SELECTION", () => {
    setVulTableSelectedKeys([]);
  });

  const dvgOptions = React.useMemo(() => {
    const options = { columns: [], className: "" };

    options.columns = vulnerabilityColumns;
    options.className = "w-750-px";

    return options;
  }, [state.activeSubmenu]);

  const fetchVulneraiblities = () => {
    dispatch(mitigatorActions.fetchVulnerabilities());
  };
  const handlePageChange = (pageNo) => {
    navigate(`${window.location.pathname}?page=${pageNo}`);
    _filter.current = { ..._filter.current, pageNo };
    fetchVulneraiblities();
  };

  return (
    <div
      className={`col w-100 h-100 overflow-hide ${dvgOptions.className}`}
      ref={_ref}
    >
      <DataGridView
        columns={dvgOptions.columns}
        dataSource={vulnerabilitiesList.map((vul) => ({
          key: vul.id,
          vulnerability_id: vul.vulnerability_id ? vul.vulnerability_id : "",
          id: vul.id ? vul.id : "",
          category: vul.category ? vul.category : "",
          vulnerability: vul.vulnerability ? vul.vulnerability : "",
          threat: vul.threat ? vul.threat : "",
        }))}
        pagination={{
          pageSize: 9,
          totalCount: vulnerabilitiesList.length,
          recentFlag: false,
          defaultPage: _filter.current.defaultPage,
          onPageChange: handlePageChange,
        }}
        getCellSemantics={(column, record) => {
          if (column.dataIndex === "vulnerability_id") {
            return {
              onLinkClick: () => {
                const p = new URLSearchParams(window.location.search);
                p.set("tab", (state.activeSubmenu || "active").toLowerCase());
                p.set("open", "view-panel");
                p.set("id", record.id);
                p.set("_ts", Date.now());

                navigate(`${window.location.pathname}?${p.toString()}`);
              },
            };
          }
          return {};
        }}
        EmptyComponent={
          <span className="ff-exo2 f16 c777">
            There are no {state.activeSubmenu.toLowerCase()} vulnerabilities
            right now!
          </span>
        }
        rowSelection={{
          type: "checkbox",
          selectedRowKeys: vulTableSelectedKeys,
          onChange: (selectedRowKeys) => {
            setVulTableSelectedKeys(selectedRowKeys);
            publish("MITIGATOR_SELECTED_VULNERABILITY_IDS", {
              ids: selectedRowKeys,
            });
          },
        }}
      />
    </div>
  );
};
